import { useAtomValue, useResetAtom, useSetAtom } from '~shared/lib/atom-state';

import { portfolioAtom, setPortfolioAtom } from './atoms';

export const usePortfolio = () => {
  return useAtomValue(portfolioAtom);
};

export const useSetPortfolio = () => {
  return useSetAtom(setPortfolioAtom);
};

export const useResetPortfolio = () => {
  return useResetAtom(portfolioAtom);
};
